import './index.scss'
import Swiper from 'swiper/swiper-bundle.min.js'
$(function () {
    $(window).scroll(function () {
        // 可是窗口滚动条发生滚动的时候 垂直方向滚动到多少距离的时候 让头部导航条设置上一个固定定位的样式
        if ($(window).scrollTop() >= ($("header").height())) {
            // alert($("#slideBox").height());
            $("header").addClass("head1");
        } else {
            $("header").removeClass("head1");
        }
    })
})


$("#nav1").addClass("active");
var swiper = new Swiper(".index-banner .mySwiper", {
    observer:true,//修改swiper自己或子元素时，自动初始化swiper
    observeParents:true,//修改swiper的父元素时，自动初始化swiper
    loop:true,
    speed:1500,
    autoplay: {
        delay: 4000,
    },
    navigation: {
        nextEl: ".index-banner .swiper-button-next",
        prevEl: ".index-banner .swiper-button-prev",
      },
    pagination: {
        el: '.index-banner .swiper-pagination',
        clickable: true,
    },
});
// 视频播放
$(".play").click(function () {
    var video = document.getElementById('myVideo');
    if (video.paused) { //如果已暂停则播放
        $('.play').hide();
        video.play(); //播放控制
    } else { // 已播放点击则暂停
        $('.play').show();
        video.pause(); //暂停控制
    }
})
var productSwiper1 = new Swiper(".swiper1 .swiper", {
    navigation: {
      nextEl: ".swiper1 .swiper-button-next",
      prevEl: ".swiper1 .swiper-button-prev",
    },
    pagination: {
        el: '.swiper1 .swiper-pagination',
        clickable: true,
    },
});
var productSwiper2 = new Swiper(".swiper2 .swiper", {
    navigation: {
      nextEl: ".swiper2 .swiper-button-next",
      prevEl: ".swiper2 .swiper-button-prev",
    },
    pagination: {
        el: '.swiper2 .swiper-pagination',
        clickable: true,
    },
});
var productSwiper3 = new Swiper(".swiper3 .swiper", {
    navigation: {
      nextEl: ".swiper3 .swiper-button-next",
      prevEl: ".swiper3 .swiper-button-prev",
    },
    pagination: {
        el: '.swiper3 .swiper-pagination',
        clickable: true,
    },
});
var productSwiper4 = new Swiper(".swiper4 .swiper", {
    navigation: {
      nextEl: ".swiper4 .swiper-button-next",
      prevEl: ".swiper4 .swiper-button-prev",
    },
    pagination: {
        el: '.swiper4 .swiper-pagination',
        clickable: true,
    },
});
// tab切换
$(".product-nav a").eq(0).addClass("active")
$(".swiper-list .swiper-product").eq(0).addClass("active");
$(".product-nav a").hover(function () {
    let index = $(this).index();
    $(this).addClass("active").siblings().removeClass("active");
    $(".swiper-list .swiper-product").eq(index).addClass("active").siblings().removeClass("active");
})

$(".section3 ul li").hover(function() {
    $(this).addClass("active").siblings().removeClass("active");
    $(this).removeClass("active1").siblings().addClass("active1");
},function() {
    $(".section3 ul li").removeClass("active");
    $(".section3 ul li").removeClass("active1");
})

// 新闻

$(".news-nav a").eq(0).addClass("active");
$(".news-list ul").eq(0).addClass("active");
$(".news-nav a").hover(function () {
    let index = $(this).index();
    $(this).addClass("active").siblings().removeClass("active");
    $(".news-list ul").eq(index).addClass("active").siblings().removeClass("active");
})

$(window).scroll(function () {
    // 可是窗口滚动条发生滚动的时候 垂直方向滚动到多少距离的时候 让头部导航条设置上一个固定定位的样式

    if ($(window).scrollTop()>=($(".section1").offset().top - 500) && $(window).scrollTop()<($(".section2").offset().top - 500)) {
        $(".section").removeClass("active");
      $(".section1").addClass("active");
    }
    else if ($(window).scrollTop()>=($(".section2").offset().top - 500) && $(window).scrollTop()<($(".section3").offset().top - 500)) {
        $(".section").removeClass("active");
      $(".section2").addClass("active")
    }
    else if ($(window).scrollTop()>=($(".section3").offset().top - 500) && $(window).scrollTop()<($(".section4").offset().top - 500)) {
        $(".section").removeClass("active");
      $(".section3").addClass("active")
    }
    else if ($(window).scrollTop()>=($(".section4").offset().top - 500)) {
        $(".section").removeClass("active");
      $(".section4").addClass("active")
        
      }
    else {
        $(".section").removeClass("active");
    }
})